"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCdnPath = exports.getApiEndpoint = void 0;

var _constants = require("./constants");

var getApiEndpoint = function getApiEndpoint(env) {
  var envPrefix = {
    prod: '',
    dev: "".concat(_constants.ENV_STRINGS.dev, "-"),
    test: "".concat(_constants.ENV_STRINGS.test, "-")
  }[env];
  return "https://".concat(_constants.API_HOST, ".").concat(envPrefix, "godaddy.com");
};

exports.getApiEndpoint = getApiEndpoint;

var getCdnPath = function getCdnPath(env) {
  var envPrefix = {
    prod: '',
    dev: "".concat(_constants.ENV_STRINGS.dev, "-"),
    test: "".concat(_constants.ENV_STRINGS.test, "-")
  }[env];
  return "//img1.".concat(envPrefix, "wsimg.com/dc-assets/help-browse");
};

exports.getCdnPath = getCdnPath;